<template>
  <div>
    <button @click="$store.dispatch('activity/load')" :disabled="isLoading">Load activity</button>
    <h3>Activity</h3>
    <div v-for="a in activity.items" :key="a.id">
      {{ a.title }}
    </div>
    <h3>My Activity</h3>
    <div v-for="a in myActivity.items" :key="a.id">
      {{ a.title }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('activity', ['activity', 'myActivity', 'isLoading']),
  },
}
</script>

<style>
</style>